namespace SorAraBul.PropertyManagement {
    export interface TenantDetailRow {
        GId?: string;
        TenantId?: number;
        Completed?: boolean;
        Step?: FormWizardSteps;
        SelfReportedName?: string;
        SelfReportedSurname?: string;
        SelfReportedPhone?: string;
        SelfReportedEmail?: string;
        Tckn?: string;
        MaskedTckn?: string;
        BirthDate?: string;
        MaritalStatus?: MaritalStatus;
        HasChildren?: boolean;
        ChildrenCount?: number;
        ChildrenAges?: string;
        WorkingAdultsCount?: number;
        OccupationSelfId?: number;
        OccupationSelfName?: string;
        OccupationSelf?: string;
        OccupationSpouseId?: number;
        OccupationSpouseName?: string;
        OccupationSpouse?: string;
        EducationLevelSelf?: EducationLevel;
        EducationLevelSpouse?: EducationLevel;
        OldAddress?: string;
        OldAddressResidenceDurationMonths?: number;
        OldAddressResidenceDurationText?: string;
        OldQuarterId?: number;
        InsertDate?: string;
        HasoKkbRefNo?: string;
        HasoCustomerId?: string;
        HasoCustomerInfo?: string;
        HasoKkbXml?: string;
        HasoBkKrediNotu?: number;
        HasoBkKrediNotuSonuc?: string;
        HasoMessage?: string;
        SorsDosyaId?: number;
        SorsMessage?: string;
        SorsData?: string;
        SorsRaporJson?: string;
        SorsRaporUrl?: string;
        SorsRaporCompleteDate?: string;
        SorsRaporRequestDate?: string;
        SorsLocalReportUrl?: string;
        HasPet?: boolean;
        PetTypes?: number[];
        TenantPropertyId?: number;
        TenantName?: string;
        TenantSurname?: string;
        TenantPhone?: string;
        TenantEmail?: string;
        TenantSmsVerificationCode?: number;
        TenantStatus?: TenantStatus;
        PropertyType?: PropertyTypes;
        PropertyName?: string;
        PropertyAddress?: string;
        PropertyImages?: string;
        PropertyRequestedRentAmount?: number;
        PropertyRequestedRentCurrencyCode?: string;
        PropertyRequestedRentAmountWithCurrency?: string;
        PropertyRestrictions?: string;
        OldCityId?: number;
        OldCityName?: string;
        OldTownId?: number;
        OldTownName?: string;
        OldQuarterName?: string;
        PropertyCityName?: string;
        PropertyTownName?: string;
        PropertyQuarterName?: string;
    }

    export namespace TenantDetailRow {
        export const idProperty = 'GId';
        export const nameProperty = 'ChildrenAges';
        export const localTextPrefix = 'PropertyManagement.TenantDetail';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            GId = "GId",
            TenantId = "TenantId",
            Completed = "Completed",
            Step = "Step",
            SelfReportedName = "SelfReportedName",
            SelfReportedSurname = "SelfReportedSurname",
            SelfReportedPhone = "SelfReportedPhone",
            SelfReportedEmail = "SelfReportedEmail",
            Tckn = "Tckn",
            MaskedTckn = "MaskedTckn",
            BirthDate = "BirthDate",
            MaritalStatus = "MaritalStatus",
            HasChildren = "HasChildren",
            ChildrenCount = "ChildrenCount",
            ChildrenAges = "ChildrenAges",
            WorkingAdultsCount = "WorkingAdultsCount",
            OccupationSelfId = "OccupationSelfId",
            OccupationSelfName = "OccupationSelfName",
            OccupationSelf = "OccupationSelf",
            OccupationSpouseId = "OccupationSpouseId",
            OccupationSpouseName = "OccupationSpouseName",
            OccupationSpouse = "OccupationSpouse",
            EducationLevelSelf = "EducationLevelSelf",
            EducationLevelSpouse = "EducationLevelSpouse",
            OldAddress = "OldAddress",
            OldAddressResidenceDurationMonths = "OldAddressResidenceDurationMonths",
            OldAddressResidenceDurationText = "OldAddressResidenceDurationText",
            OldQuarterId = "OldQuarterId",
            InsertDate = "InsertDate",
            HasoKkbRefNo = "HasoKkbRefNo",
            HasoCustomerId = "HasoCustomerId",
            HasoCustomerInfo = "HasoCustomerInfo",
            HasoKkbXml = "HasoKkbXml",
            HasoBkKrediNotu = "HasoBkKrediNotu",
            HasoBkKrediNotuSonuc = "HasoBkKrediNotuSonuc",
            HasoMessage = "HasoMessage",
            SorsDosyaId = "SorsDosyaId",
            SorsMessage = "SorsMessage",
            SorsData = "SorsData",
            SorsRaporJson = "SorsRaporJson",
            SorsRaporUrl = "SorsRaporUrl",
            SorsRaporCompleteDate = "SorsRaporCompleteDate",
            SorsRaporRequestDate = "SorsRaporRequestDate",
            SorsLocalReportUrl = "SorsLocalReportUrl",
            HasPet = "HasPet",
            PetTypes = "PetTypes",
            TenantPropertyId = "TenantPropertyId",
            TenantName = "TenantName",
            TenantSurname = "TenantSurname",
            TenantPhone = "TenantPhone",
            TenantEmail = "TenantEmail",
            TenantSmsVerificationCode = "TenantSmsVerificationCode",
            TenantStatus = "TenantStatus",
            PropertyType = "PropertyType",
            PropertyName = "PropertyName",
            PropertyAddress = "PropertyAddress",
            PropertyImages = "PropertyImages",
            PropertyRequestedRentAmount = "PropertyRequestedRentAmount",
            PropertyRequestedRentCurrencyCode = "PropertyRequestedRentCurrencyCode",
            PropertyRequestedRentAmountWithCurrency = "PropertyRequestedRentAmountWithCurrency",
            PropertyRestrictions = "PropertyRestrictions",
            OldCityId = "OldCityId",
            OldCityName = "OldCityName",
            OldTownId = "OldTownId",
            OldTownName = "OldTownName",
            OldQuarterName = "OldQuarterName",
            PropertyCityName = "PropertyCityName",
            PropertyTownName = "PropertyTownName",
            PropertyQuarterName = "PropertyQuarterName"
        }
    }
}
